/** Leading/trailing icon column width (ListItemIcon). */
export const Q_MENU_ICON_SLOT_SIZE = 24;

/** Glyph size inside the slot — matches MUI SvgIcon `fontSize="small"`. */
export const Q_MENU_ICON_GLYPH_SIZE = 20;

/**
 * Slot chrome for start/end icons. Sizes only *direct* glyph children so nested
 * icons (e.g. UsageAndEntityIcon Avatar) keep their own proportions.
 */
export const Q_MENU_ICON_SLOT_SX = {
  minWidth: Q_MENU_ICON_SLOT_SIZE,
  width: Q_MENU_ICON_SLOT_SIZE,
  mr: 1,
  justifyContent: 'center',
  '& > .MuiSvgIcon-root, & > svg, & > img': {
    fontSize: Q_MENU_ICON_GLYPH_SIZE,
    width: Q_MENU_ICON_GLYPH_SIZE,
    height: Q_MENU_ICON_GLYPH_SIZE,
  },
} as const;

/** Trailing end-icon wrapper (no ListItemIcon minWidth). */
export const Q_MENU_END_ICON_SX = {
  ml: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: Q_MENU_ICON_SLOT_SIZE,
  minWidth: Q_MENU_ICON_SLOT_SIZE,
  '& > .MuiSvgIcon-root, & > svg, & > img': {
    fontSize: Q_MENU_ICON_GLYPH_SIZE,
    width: Q_MENU_ICON_GLYPH_SIZE,
    height: Q_MENU_ICON_GLYPH_SIZE,
  },
} as const;
